import { createGridMediaQuery, mediaQueriesArray } from './createMediaQuery';
import type { ResponsiveSpacing } from './types';

export const createResponsiveGridStyle = (cssProp: string, value: ResponsiveSpacing) => {
  if (typeof value === 'number') {
    return `${cssProp}: ${value}px !important`;
  } else if (typeof value === 'string') {
    return `${cssProp}: ${value} !important`;
  } else if (Array.isArray(value)) {
    return mediaQueriesArray(cssProp, value, createGridMediaQuery);
  }
  return null;
};
